/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceStatus
 */
export interface ServiceStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceStatus
     */
    running: boolean;
}

export function ServiceStatusFromJSON(json: any): ServiceStatus {
    return ServiceStatusFromJSONTyped(json, false);
}

export function ServiceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'running': json['running'],
    };
}

export function ServiceStatusToJSON(value?: ServiceStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'running': value.running,
    };
}


